import * as React from 'react';

type Tone = 'green' | 'amber' | 'red' | 'blue' | 'gray' | 'slate';

const TONES: Record<Tone, { color: string; bg: string }> = {
  green: { color: '#047857', bg: 'rgba(5, 150, 105, 0.12)' },
  amber: { color: '#b45309', bg: 'rgba(245, 158, 11, 0.14)' },
  red: { color: '#b91c1c', bg: 'rgba(220, 38, 38, 0.12)' },
  blue: { color: '#1d4ed8', bg: 'rgba(37, 99, 235, 0.12)' },
  gray: { color: '#4b5563', bg: 'rgba(75, 85, 99, 0.10)' },
  slate: { color: '#334155', bg: 'rgba(51, 65, 85, 0.10)' }
};

export const Pill: React.FunctionComponent<{ text: string; tone: Tone }> = ({ text, tone }) => {
  const t = TONES[tone];
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '3px 9px',
        borderRadius: 9999,
        background: t.bg,
        color: t.color,
        fontSize: 11.5,
        fontWeight: 700,
        letterSpacing: '0.2px',
        whiteSpace: 'nowrap'
      }}
    >
      {text.replace(/_/g, ' ')}
    </span>
  );
};

const CAMPAIGN_TONE: Record<string, Tone> = {
  DRAFT: 'gray',
  SCHEDULED: 'blue',
  ACTIVE: 'green',
  COMPLETED: 'slate',
  PARTIALLY_COMPLETE: 'amber',
  NEEDS_RUNS: 'amber',
  STOPPED_BY_OWNER: 'gray'
};

const RUN_TONE: Record<string, Tone> = {
  PENDING: 'gray',
  IN_PROGRESS: 'green',
  COMPLETED: 'slate',
  ABORTED: 'red',
  PAUSED: 'amber'
};

const APPROVAL_TONE: Record<string, Tone> = {
  PENDING_APPROVAL: 'amber',
  APPROVED: 'green',
  DECLINED: 'red',
  NO_DRIVER_AVAILABLE: 'red',
  CANCELLED: 'gray'
};

export const CampaignStateBadge: React.FunctionComponent<{ state: string | null }> = ({ state }) =>
  state ? <Pill text={state} tone={CAMPAIGN_TONE[state] || 'gray'} /> : <>—</>;

export const RunStateBadge: React.FunctionComponent<{ state: string | null }> = ({ state }) =>
  state ? <Pill text={state} tone={RUN_TONE[state] || 'gray'} /> : <>—</>;

export const ApprovalBadge: React.FunctionComponent<{ state: string | null }> = ({ state }) =>
  state ? <Pill text={state} tone={APPROVAL_TONE[state] || 'gray'} /> : <>—</>;
